import React from 'react';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { isExternalLink } from 'utils/is-external-link';

import { ExternalLinkStyled } from './loyalty-points-meter-widget.styled';

interface ILoyaltyPointsMeterWidgetCtaProps {
  buttonText: string;
  buttonPath: string;
  onCtaPress: (url?: string) => void;
}

export const LoyaltyPointsMeterWidgetCta = ({
  buttonText,
  buttonPath,
  onCtaPress,
}: ILoyaltyPointsMeterWidgetCtaProps) => {
  const isExternal = isExternalLink(buttonPath);
  if (isExternal) {
    return (
      <ExternalLinkStyled to={buttonPath} isExternal>
        {buttonText}
      </ExternalLinkStyled>
    );
  }

  return (
    <ActionButton
      to={buttonPath}
      onPress={() => onCtaPress(buttonPath)}
      variant={ActionButtonVariants.INVERSE}
      paddingLeft="$8"
      paddingRight="$8"
      marginY="$4"
      marginX="auto"
    >
      {buttonText}
    </ActionButton>
  );
};
